





import BaseComponent from '@/core/base.component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'NonLayout',
})
export default class NonLayout extends BaseComponent {}
